import { UntypedFormControl } from '@angular/forms';

export function zipValidator(control: UntypedFormControl): { [s: string]: boolean } {
  const zip = control.value;

  if (!zip) {
    return null;
  }

  if (!zip.match(/^[0-9]{5}$|^[0-9]{5}\-[0-9]{4}$/)) {
    return { invalidZip: true };
  }

  return null;
}

export function stateValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value.length !== 2) {
    return { invalidState: true };
  }
}

export function zipValidatorMessage(): string {
  return 'ZIP must be in the form 12345 or 12345-1234.';
}

export function cityValidator(control: UntypedFormControl): { [s: string]: boolean } {
  const city = control.value;

  if (!city) {
    return null;
  }

  if (!city.match(/^[^-\s][a-zA-Z\s-]+$/) || city.trim() === '') {
    return { invalidCity: true };
  }

  return null;
}

export function cityValidatorMessage(): string {
  return 'Please enter valid city name';
}
